var map = {
	"./about.md": 8045,
	"./config": 5489,
	"./config.json": 5489,
	"./links": 5824,
	"./links.json": 5824,
	"./posts": 9762,
	"./posts.json": 9762,
	"./project-des.md": 4748,
	"./projects": 5689,
	"./projects.json": 5689
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4612;